import React, { useState } from 'react';
import ReactPaginate from 'react-paginate';
import { useTranslation } from 'react-i18next';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';
import availableIcon from '../image/free-icon-check-14090371.png';
import unavailableIcon from '../image/free-icon-multiply-399274.png';
import Table from 'react-bootstrap/Table'; // Импортируем компонент Table

function DirectoryTable({ columns, data, onEdit, onDelete, onAdd, searchQuery, onSearchChange }) {
  const { t } = useTranslation();
  const [currentPage, setCurrentPage] = useState(0);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [selectedRow, setSelectedRow] = useState(null);
  const itemsPerPage = 10;

  const handlePageClick = (selectedPage) => {
    setCurrentPage(selectedPage.selected);
  };

  const offset = currentPage * itemsPerPage;
  const currentItems = data.slice(offset, offset + itemsPerPage);
  const pageCount = Math.ceil(data.length / itemsPerPage);

  const handleDelete = () => {
    onDelete(itemToDelete);
    setShowConfirmModal(false);
  };

  const confirmDelete = (row) => {
    setItemToDelete(row);
    setShowConfirmModal(true);
  };

  const handleRowClick = (row) => {
    setSelectedRow(row);
    onEdit(row);
  };

  return (
    <div className="card">
      <div className="card-header">
        <input
          type="text"
          placeholder={t('search_by_param')}
          className="form-control"
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          style={{ width: '200px', display: 'inline-block', marginRight: '20px' }}
        />
      </div>
      <div className="card-body p-0">
        <Table hover striped bordered className="projects">
          <thead>
            <tr>
              <th style={{ width: '5%' }}>#</th>
              {columns
                .filter(column => !['equipment_id', 'division_id', 'nomenclature_id', 'enterprise_id', 'equipment_group_id'].includes(column.accessor))
                .map((column, idx) => (
                  <th key={idx} style={{ width: 'auto' }}>{t(column.header)}</th>
              ))}
              <th style={{ width: '20%', minWidth: '236px' }}>{/* Удаляем колонку с действиями */}</th>
            </tr>
          </thead>
          <tbody>
            {currentItems.map((row, idx) => (
              <tr
                key={idx}
                onClick={() => handleRowClick(row)}
                className={selectedRow === row ? 'table-active' : ''}
                style={{ cursor: 'pointer' }}
              >
                <td>{offset + idx + 1}</td>
                {columns
                  .filter(column => !['equipment_id', 'division_id', 'nomenclature_id', 'enterprise_id', 'equipment_group_id'].includes(column.accessor))
                  .map((column, colIdx) => (
                    <td key={colIdx}>
                      {column.accessor === 'status' ? (
                        row[column.accessor] === 'available' ? (
                          <img src={availableIcon} alt="Available" style={{ width: '20px', height: '20px' }} />
                        ) : (
                          <img src={unavailableIcon} alt="Unavailable" style={{ width: '20px', height: '20px' }} />
                        )
                      ) : (
                        row[column.accessor]
                      )}
                    </td>
                ))}
                <td className="project-actions text-right" style={{ width: '17%', minWidth: '236px' }}>
                  <button className="btn btn-danger btn-sm" onClick={(e) => { e.stopPropagation(); confirmDelete(row); }}>
                    <i className="fas fa-trash mr-1"></i>{t('delete')}
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </Table>
      </div>
      <div className="card-footer">
        <div className="d-flex justify-content-between">
          <button className="btn btn-primary" onClick={onAdd}>
            {t('add_new')}
          </button>
          <ReactPaginate
            previousLabel={t('prev')}
            nextLabel={t('next')}
            breakLabel={'...'}
            breakClassName={'page-item'}
            breakLinkClassName={'page-link'}
            pageCount={pageCount}
            marginPagesDisplayed={2}
            pageRangeDisplayed={3}
            onPageChange={handlePageClick}
            containerClassName={'pagination'}
            pageClassName={'page-item'}
            pageLinkClassName={'page-link'}
            previousClassName={'page-item'}
            previousLinkClassName={'page-link'}
            nextClassName={'page-item'}
            nextLinkClassName={'page-link'}
            activeClassName={'active'}
          />
        </div>
      </div>

      {/* Модальное окно подтверждения удаления */}
      <Modal show={showConfirmModal} onHide={() => setShowConfirmModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>{t('confirm_delete_title')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>{t('confirm_delete_message')}</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirmModal(false)}>
            {t('cancel')}
          </Button>
          <Button variant="danger" onClick={handleDelete}>
            {t('delete')}
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
}

export default DirectoryTable;
